import React from "react";
import { InvoiceViewContext } from "./invoice-view-context";
import { usePageInvoiceViewHook } from "./invoice-view-hooks";

export function PageContextInvoiceViewProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const value = usePageInvoiceViewHook();

  return (
    <InvoiceViewContext.Provider value={value}>
      {children}
    </InvoiceViewContext.Provider>
  );
}
